import { USER_ACTION_TYPES } from "./user.types";
import { createAction } from "../../utils/reducer/reducer.utils"
import { UserInfo } from "../../types/user/userInfo.type";

export const setUser = (user: UserInfo) => createAction(USER_ACTION_TYPES.SET_USER, user);